import React from 'react';
import { LabelMedium } from '../common/GlobalElements/Typography';
import { tokens } from '../../public/tokens';

const disabledInputStyle = {
    backgroundColor: tokens.colors.surfaces['page-background'],
    border: `1px solid ${tokens.colors.ui.border}`,
};

/**
 * Read-only labelled text field for displaying a value the user can't edit.
 */
const DisabledInput = ({ label, placeholder, value }) => (
    <div className="form-group" title={label}>
        <LabelMedium>{label}</LabelMedium>
        <input
            type="text"
            className="form-control"
            placeholder={placeholder}
            value={value}
            disabled
            style={disabledInputStyle}
        />
    </div>
);

export default DisabledInput;
